module.exports = __webpack_public_path__ + "img/media-keyboard.eca25bf7.png";